// extracted by mini-css-extract-plugin
export var closeButton = "_df-1";
export var closeX = "_df-3";
export var container = "_df-0";
export var image = "_df-2";